import type {User} from '@/types/User';
import {useCallback} from 'react';

const useStripeCompleteSetupIntent = (): ((
    user: User,
    setupId: string,
    setupClientSecret: string,
    paymentMethod: string,
    membershipTypeId: string,
    setupIntentId: string,
) => Promise<Response>) => {
    return useCallback(
        async (
            user: User,
            setupId: string,
            setupClientSecret: string,
            paymentMethod: string,
            membershipTypeId: string,
            setupIntentId: string,
        ): Promise<Response> => {
            const url = new URL(
                '/payment/complete-setup-intent',
                import.meta.env.VITE_APP_API_ENDPOINT,
            );

            return await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: user.email,
                    fullName: user.fullName,
                    setupId: setupId,
                    setupClientSecret: setupClientSecret,
                    paymentMethod: paymentMethod,
                    membershipTypeId: membershipTypeId,
                    memberId: user.memberId,
                    setupIntentId: setupIntentId,
                }),
            });
        },
        [],
    );
};

export default useStripeCompleteSetupIntent;
